import type { IExtractRouteParamMap } from "../../../types";
import { facultyBreadcrumbs, facultyRoutesObj } from "../faculty/path";

import {
  concatBreadcrumbs,
  createBreadcrumbObject,
  createPaths,
  rebase,
} from "@/routes/utils";
import {
  facultyMembersRoutesObj,
  facultyMembersRouteTranslation,
} from "@routes/admin/usersManagement/facultyMembers/path";

const baseRoute = facultyRoutesObj.view;

// * Route configuration object for membersOfFaculty-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const membersOfFacultyRoutesObj = {
  list: `${baseRoute}${facultyMembersRoutesObj.list}`,
  create: `${baseRoute}${facultyMembersRoutesObj.create}`,
  view: `${baseRoute}${facultyMembersRoutesObj.view}`,
  edit: `${baseRoute}${facultyMembersRoutesObj.edit}`,
} as const;

// * Extracts the route parameters for the membersOfFaculty route configuration.
export type IMembersOfFacultyRouteParams = IExtractRouteParamMap<
  typeof membersOfFacultyRoutesObj
>;

// * Path functions for the membersOfFaculty routes.
export const membersOfFacultyPath = createPaths<
  typeof membersOfFacultyRoutesObj,
  IMembersOfFacultyRouteParams
>(membersOfFacultyRoutesObj);

// * Breadcrumbs {translation and route} for the membersOfFaculty routes
const newMembersOfFaculty = createBreadcrumbObject<
  typeof membersOfFacultyRoutesObj
>(membersOfFacultyRoutesObj, facultyMembersRouteTranslation);

rebase(newMembersOfFaculty, "list");

export const membersOfFacultyBreadcrumbs = concatBreadcrumbs<
  typeof membersOfFacultyRoutesObj
>(facultyBreadcrumbs.view, newMembersOfFaculty);
